import { Compartment } from '@codemirror/state';
import React from 'react';
export const useExtension = (ext, deps) => {
  const compartment = React.useRef(new Compartment());
  const hasInit = React.useRef(false);
  const extRef = React.useRef(ext);
  extRef.current = ext;
  const init = React.useCallback(() => {
    hasInit.current = true;
    return compartment.current.of(extRef.current());
  }, []);
  const effects = React.useMemo(() => {
    if (!hasInit.current) return undefined;
    return [function updateExtension(editor) {
      editor.dispatch({
        effects: compartment.current.reconfigure(extRef.current())
      });
    }];
  }, deps || []);
  return {
    init: init,
    effects: effects
  };
};